import styled from "styled-components";

import { SPACING } from "../../../../utils/constants";

export const TransferSummary = styled.p`
  margin: ${SPACING.sm}px 0 0;
  color: var(--color-text-secondary);
  font-size: var(--text-sm);
  line-height: 1.45;
`;
